import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-summary-report-v2',
  templateUrl: './summary-report-v2.component.html',
  styleUrls: ['./summary-report-v2.component.scss']
})
export class SummaryReportV2Component {

  public summaries:any = [];
  public permission:any = {};
  public is_loading = false;
  public filterMonth: string;
  public is_mario:boolean = false;

  constructor(private http: HttpService) {

    this.init();

    const now = new Date();
    this.filterMonth = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2);

    this.getData();

  }

  async init() {
    this.permission = await this.http.getHiddenPermission()
  }

  monthChange(val:any) {
    this.filterMonth = val.target.value;
    this.getData(val.target.value + "-01");
  }

  async getData(today = null) {

    if(today) {
      today = new Date(today);
    } else {
      today = new Date();
    }

    const curYear = today.getFullYear();
    const curMonth = today.getMonth(); // 0-indexed
    const prevMonth = curMonth === 0 ? 11 : curMonth - 1;
    const prevYear = curMonth === 0 ? curYear - 1 : curYear;

    let months = [
      curYear + "-" + ("0" + (curMonth + 1)).slice(-2),
      prevYear + "-" + ("0" + (prevMonth + 1)).slice(-2)
    ];

    this.load(months);
  }

  async save(account) {
    let y:any = await this.http.post("/admin/summary-account-v2/save", account);
  }

  async load(months) {
    this.is_loading = true;
    let y:any = await this.http.post("/admin/summary-account-v2/get", {months});

    if(y.status) {
      this.summaries = y.summaries;
    }
    this.is_loading = false;

  }

  sum(key, arr) {
    let val = arr.map((v:any) => {
      return parseFloat(v[key]) ?? 0
    })

    return val.reduce((partialSum, a) => partialSum + a, 0);
  }

  update(account) {
    account.cash = parseFloat(account.capital ?? 0) +  parseFloat(account.net_profit ?? 0) -  parseFloat(account.withdraw_capital ?? 0) +  parseFloat(account.add_capital ?? 0)
  }

  // Recompute Cash live when an admin edits "Last Month Cash" (cash_bf).
  // Mirrors the backend formula in accountSummaryByCompanyByMonth:
  //   cash = net_profit + cash_bf + current_month_capital
  updateCash(account) {
    let toNum = (v) => { let n = parseFloat(v); return Number.isFinite(n) ? n : 0; };
    account.cash = toNum(account.net_profit) + toNum(account.cash_bf) + toNum(account.current_month_capital);
  }

  latestArray() {
    let y = []
    y.push(this.summaries[0])
    console.log(this.summaries, y)
    return y
  }

}
